import React from 'react';
import { useStoreContext } from '../../contexts/StoreContext';
import ReviterHomePage from '../../pages/ReviterHomePage';
import SupplierHomePage from '../../pages/supplier/SupplierHomePage';
import Skeleton from '../common/Skeleton';
import Container from './Container';

// Despacha "/" entre LP institucional do Reviter (sem tenant) e home do
// storefront whitelabel (com tenant resolvido por host ou ?tenantId=).
// Enquanto o StoreProvider resolve, mostra skeleton — evita flash da LP em
// hosts de loja.
const RootRoute = () => {
  const { isStoreSite, loading } = useStoreContext();

  if (loading) {
    return (
      <Container>
        <div className="py-10">
          <Skeleton variant="block" height={320} />
        </div>
      </Container>
    );
  }

  return isStoreSite ? <SupplierHomePage /> : <ReviterHomePage />;
};

export default RootRoute;
